import { render } from "./AddressList.vue?vue&type=template&id=0af5be7b&ts=true"
import script from "./AddressList.vue?vue&type=script&lang=tsx"
export * from "./AddressList.vue?vue&type=script&lang=tsx"

import "./AddressList.vue?vue&type=style&index=0&id=0af5be7b&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__